import angular from 'angular';

import '../../../main/factory/invoicingEmail';
import '../../../main/factory/authentication';

document.write(require('./view.html').default);
import './style.scss';

angular.module("merchant.application.module.invoicingEmail.create", [
]).controller("merchant.application.module.invoicingEmail.create.controller", [
    "$rootScope", "$scope", "$controller",
    "merchant.application.main.factory.invoicingEmail",
    "merchant.application.main.factory.authentication",
    function($rootScope, $scope, $controller, InvoicingEmail, Authentication) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        if (! $scope.model.invoiceEmail) {
            $scope.model.invoiceEmail = {};
        }

        $scope.model.invoiceEmail.data = {};
        $scope.model.invoiceEmail.saved = false;
        $scope.model.invoiceEmail.duplicateEmail = false;

        $scope.submit = function() {
            $scope.model.currentError = null;

            if ($scope.form.$valid) {
                var merchantId = Authentication.merchantId();
                var data = $scope.model.invoiceEmail.data;
                data.merchantId = merchantId;

                InvoicingEmail.create(data, function (data) {
                    $scope.model.invoiceEmail.saved = true;
                    $rootScope.$broadcast("invoiceEmailSaved", data);
                }, function (error) {
                    $scope.handleError(error);
                });
            }
        };

        $scope.handleError = function(error) {
            if (error.data && error.data.errorCode === "duplicate_email") {
                $scope.model.invoiceEmail.duplicateEmail = true;
            } else {
                $scope.model.currentError = error.data && error.data.errorCode;
            }
        };
    }
]);
